  // --- VIRTUAL DRAWER LOGIC ---

  var MAX_FREE_SAMPLES = 6; // keep in sync with configurator.js sampleState.maxSamples

  function readVirtualCart() {
    try {
      const cart = JSON.parse(localStorage.getItem('virtual_cart') || '[]');
      return Array.isArray(cart) ? cart : [];
    } catch (e) {
      return [];
    }
  }

  function isSampleStocked(item) {
    if (!item || item.product_type !== 'sample') return true;
    try {
      if (window.BYBStock && typeof window.BYBStock.isStocked === 'function') {
        return window.BYBStock.isStocked('sample', item.fabric, item.colour);
      }
    } catch (e) {}
    return true;
  }

  function capVirtualCartSamples(cart) {
    var samples = 0;
    var next = [];
    (cart || []).forEach(function(item) {
      if (item && item.product_type === 'sample') {
        if (!isSampleStocked(item)) return;
        if (samples >= MAX_FREE_SAMPLES) return;
        samples++;
      }
      next.push(item);
    });
    return next;
  }

  function getVirtualCartCount() {
    try {
      const cart = capVirtualCartSamples(readVirtualCart());
      return cart.length;
    } catch (e) {
      return 0;
    }
  }

  function updateHeaderCartCount() {
    const countEl = document.querySelector('.ind-cart-btn-count');
    if (!countEl) return;

    const count = getVirtualCartCount();
    const btn = countEl.closest('.ind-cart-btn');
    countEl.textContent = count > 0 ? ` (${count})` : '';

    if (btn) {
      btn.setAttribute(
        'aria-label',
        count === 0 ? 'View cart, empty' : `View cart, ${count} item${count === 1 ? '' : 's'}`
      );
    }
  }

  window.updateHeaderCartCount = updateHeaderCartCount;

  // 1. OPEN/CLOSE
  function openVirtualDrawer() {
    renderVirtualItems();
    document.getElementById('virtual-cart-drawer').classList.add('open');
    document.body.classList.add('cart-is-open');
  }
  function closeVirtualDrawer() {
    document.getElementById('virtual-cart-drawer').classList.remove('open');
    document.body.classList.remove('cart-is-open');
  }

  // 2. TOGGLE CONFIGURATION ACCORDION
  window.toggleConfig = function(id) {
      const el = document.getElementById('config-' + id);
      const btn = document.getElementById('btn-config-' + id);
      if(el) {
          el.classList.toggle('show');
          btn.innerText = el.classList.contains('show') ? 'Hide Details' : 'View Full Configuration';
      }
  };

  // 3. RENDER ITEMS
  function renderVirtualItems() {
    let cart = capVirtualCartSamples(readVirtualCart());
    if (JSON.stringify(cart) !== JSON.stringify(readVirtualCart())) {
      localStorage.setItem('virtual_cart', JSON.stringify(cart));
    }
    const container = document.getElementById('vc-items-container');
    const countSpan = document.getElementById('vc-count');
    const subtotalSpan = document.getElementById('vc-subtotal');
    
    countSpan.innerText = cart.length;
    updateHeaderCartCount();
    container.innerHTML = "";
    
    if(cart.length === 0) {
      container.innerHTML = '<div class="empty-state">Your cart is empty.</div>';
      subtotalSpan.innerText = "$0.00";
      document.getElementById('vc-discount-row') && (document.getElementById('vc-discount-row').style.display = 'none');
      document.getElementById('vc-total-row') && (document.getElementById('vc-total-row').style.display = 'none');
      updateDiscountAppliedUI();
      return;
    }

    let total = 0;

    cart.forEach((item, index) => {
      total += (item.price || 0);
      
      // Dynamic Title & Basics
      let title;
      if(item.product_type === 'sample') {
        const sampleParts = [item.fabric, item.colour].filter(Boolean).join(' · ');
        const typeBit = item.category ? ` (${item.category})` : '';
        title = `Sample: ${sampleParts || item.fabric}${typeBit}`;
      } else {
        title = `Custom ${item.product_type === 'blind' ? 'Blind' : 'Curtain'}`;
      }
      if(item.product_type === 'curtain' && item.curtain_layer_mode === 'double') {
        title = 'Custom Double Curtain';
      }

      let basicsHtml = "";
      if(item.product_type !== 'sample') {
         // Show the critical stuff always
         basicsHtml += `<span class="vc-meta"><strong>${item.width}mm x ${item.drop}mm</strong></span>`;
         if(item.product_type === 'curtain' && item.options && item.options.wallToWall === 'Wall to wall') {
            const opening = item.measured_width || (item.width + 20);
            basicsHtml += `<span class="vc-meta">Wall to wall · opening ${opening}mm → ${item.width}mm track (−20mm)</span>`;
         } else if(item.product_type === 'curtain' && item.options && item.options.wallToWall) {
            basicsHtml += `<span class="vc-meta">${item.options.wallToWall}</span>`;
         }
         if(item.product_type === 'curtain' && item.options && item.options.hemFinish) {
            basicsHtml += `<span class="vc-meta">Hem: ${item.options.hemFinish}</span>`;
         }
         if(item.product_type === 'curtain' && item.curtain_layer_mode === 'double') {
            basicsHtml += `<span class="vc-meta"><strong>Sheer:</strong> ${item.sheer?.fabric || '-'}</span>`;
            basicsHtml += `<span class="vc-meta"><strong>Sheer Colour:</strong> ${item.sheer?.colour || '-'}</span>`;
            basicsHtml += `<span class="vc-meta"><strong>Blockout:</strong> ${item.blockout?.fabric || '-'}</span>`;
            basicsHtml += `<span class="vc-meta"><strong>Blockout Colour:</strong> ${item.blockout?.colour || '-'}</span>`;
         } else {
            basicsHtml += `<span class="vc-meta">${item.fabric}</span>`;
            if(item.colour) basicsHtml += `<span class="vc-meta">Colour: ${item.colour}</span>`;
         }
         if(item.product_type === 'curtain' && item.options && item.options.hemFinish) {
            basicsHtml += `<span class="vc-meta">Hem: ${item.options.hemFinish}</span>`;
         }
         if(item.reference) basicsHtml += `<span class="vc-meta">Ref: "${item.reference}"</span>`;
      } else {
         if(item.category) basicsHtml += `<span class="vc-meta">${item.sample_type === 'curtain' ? 'Curtain' : 'Blind'} · ${item.category}</span>`;
         if(item.colour) basicsHtml += `<span class="vc-meta">Colour: ${item.colour}</span>`;
      }

      // BUILD FULL CONFIG LIST (Hidden by default)
      let fullConfigHtml = "";
      if (item.options && Object.keys(item.options).length > 0) {
          fullConfigHtml += `<div id="config-${index}" class="vc-full-config">`;
          
          // Loop through every saved option
          for (const [key, value] of Object.entries(item.options)) {
              fullConfigHtml += `
                  <div class="vc-config-row">
                      <span class="vc-key">${key}:</span>
                      <span class="vc-val">${value}</span>
                  </div>`;
          }
          fullConfigHtml += `</div>`;
      }

      // Generate HTML
      const div = document.createElement('div');
      div.className = 'vc-item';
      
      // Actions Row: Remove | View Configuration
      let actionsHtml = `<div class="vc-actions"><button class="vc-remove vc-btn-link" onclick="removeVirtualItem(${index})">Remove</button>`;
      
      if(item.product_type !== 'sample') {
          actionsHtml += `<button id="btn-config-${index}" class="vc-btn-link" onclick="toggleConfig(${index})">View Full Configuration</button>`;
      }
      actionsHtml += `</div>`;

      div.innerHTML = `
        <div class="vc-img" style="background-image:url('https://cdn.shopify.com/s/files/1/0974/1847/7877/files/blind-icon-placeholder.png')"></div>
        <div class="vc-details">
          <span class="vc-title">${title}</span>
          ${basicsHtml}
          ${fullConfigHtml}
          <span class="vc-price">$${item.price.toFixed(2)}</span>
          ${actionsHtml}
        </div>
      `;
      container.appendChild(div);
    });

    subtotalSpan.innerText = "$" + total.toFixed(2);

    // Discount: only use sessionStorage (validated at Apply). Never trust input alone for display.
    var appliedCode = getAppliedDiscount();
    var discountRow = document.getElementById('vc-discount-row');
    var totalRow = document.getElementById('vc-total-row');
    var discountAmountEl = document.getElementById('vc-discount-amount');
    var vcTotalEl = document.getElementById('vc-total');
    var discountLabelEl = document.getElementById('vc-discount-label');

    if (appliedCode === 'BLINDS15' && total > 0) {
      var discountAmount = total * 0.15;
      var totalAfterDiscount = total - discountAmount;
      discountRow.style.display = 'flex';
      totalRow.style.display = 'flex';
      if (discountLabelEl) discountLabelEl.textContent = 'BLINDS15';
      if (discountAmountEl) discountAmountEl.textContent = '-$' + discountAmount.toFixed(2);
      if (vcTotalEl) vcTotalEl.textContent = '$' + totalAfterDiscount.toFixed(2);
    } else {
      if (discountRow) discountRow.style.display = 'none';
      if (totalRow) totalRow.style.display = 'none';
    }

    updateDiscountAppliedUI();
  }

  // SessionStorage key: single source of truth for applied discount (validated on Apply)
  var VC_DISCOUNT_KEY = 'vc_applied_discount';
  var VALID_DISCOUNT_CODES = ['BLINDS15'];

  function getAppliedDiscount() {
    try {
      return sessionStorage.getItem(VC_DISCOUNT_KEY);
    } catch (e) {
      return null;
    }
  }

  function setAppliedDiscount(code) {
    try {
      if (code) sessionStorage.setItem(VC_DISCOUNT_KEY, code);
      else sessionStorage.removeItem(VC_DISCOUNT_KEY);
    } catch (e) {}
  }

  function updateDiscountAppliedUI() {
    var applied = getAppliedDiscount();
    var appliedBlock = document.getElementById('vc-discount-applied');
    var appliedText = document.getElementById('vc-discount-applied-text');
    var inputRow = document.querySelector('.vc-discount-input-row');
    if (!appliedBlock || !appliedText) return;
    if (applied) {
      appliedBlock.style.display = 'flex';
      appliedText.textContent = '15% off applied at checkout.';
      if (inputRow) inputRow.style.display = 'none';
    } else {
      appliedBlock.style.display = 'none';
      if (inputRow) inputRow.style.display = 'flex';
    }
  }

  function applyDiscount() {
    var input = document.getElementById('vc-discount-code');
    var messageEl = document.getElementById('vc-discount-message');
    if (!input || !messageEl) return;
    var raw = (input.value || '').trim().toUpperCase();
    messageEl.classList.remove('success', 'error');
    messageEl.textContent = '';
    if (!raw) {
      setAppliedDiscount(null);
      messageEl.textContent = 'Enter a code and click Apply.';
      messageEl.classList.add('error');
      renderVirtualItems();
      return;
    }
    if (VALID_DISCOUNT_CODES.indexOf(raw) !== -1) {
      setAppliedDiscount(raw);
      messageEl.textContent = '';
      messageEl.classList.remove('error');
      renderVirtualItems();
      return;
    }
    setAppliedDiscount(null);
    messageEl.textContent = 'Invalid discount code.';
    messageEl.classList.add('error');
    renderVirtualItems();
  }

  function removeDiscount() {
    setAppliedDiscount(null);
    var messageEl = document.getElementById('vc-discount-message');
    if (messageEl) { messageEl.textContent = ''; messageEl.classList.remove('success', 'error'); }
    var input = document.getElementById('vc-discount-code');
    if (input) input.value = '';
    renderVirtualItems();
  }

  (function attachDiscountHandlers() {
    var applyBtn = document.getElementById('vc-apply-discount-btn');
    var removeBtn = document.getElementById('vc-remove-discount-btn');
    if (applyBtn) applyBtn.addEventListener('click', applyDiscount);
    if (removeBtn) removeBtn.addEventListener('click', removeDiscount);
  })();

  // 4. REMOVE ITEM
  window.removeVirtualItem = function(index) {
    let cart = JSON.parse(localStorage.getItem('virtual_cart') || "[]");
    cart.splice(index, 1); 
    localStorage.setItem('virtual_cart', JSON.stringify(cart));
    renderVirtualItems(); 
    window.dispatchEvent(new Event('storage')); 
  };

  // --- Attribution + conversion events (marketing A) ---
  var BYB_ATTR_KEY = 'byb_attribution';
  var BYB_ATTR_KEYS = [
    'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term',
    'gclid', 'fbclid', 'ttclid', 'msclkid'
  ];

  function bybNewEventId() {
    try {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID();
      }
    } catch (e) {}
    return 'byb_' + Date.now() + '_' + Math.random().toString(36).slice(2, 10);
  }

  function bybReadStoredAttribution() {
    try {
      var raw = sessionStorage.getItem(BYB_ATTR_KEY);
      if (!raw) return {};
      var parsed = JSON.parse(raw);
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (e) {
      return {};
    }
  }

  function bybCaptureAttributionFromUrl() {
    var next = bybReadStoredAttribution();
    var changed = false;
    try {
      var params = new URLSearchParams(window.location.search || '');
      BYB_ATTR_KEYS.forEach(function (key) {
        var val = params.get(key);
        if (val) {
          next[key] = String(val).slice(0, 256);
          changed = true;
        }
      });
    } catch (e) {}
    if (changed) {
      try { sessionStorage.setItem(BYB_ATTR_KEY, JSON.stringify(next)); } catch (e2) {}
    }
    return next;
  }

  function bybBuildAttribution(eventId, cart) {
    var stored = bybCaptureAttributionFromUrl();
    var hasSample = (cart || []).some(function (item) {
      return item && item.product_type === 'sample';
    });
    return {
      event_id: eventId,
      utm_source: stored.utm_source || '',
      utm_medium: stored.utm_medium || '',
      utm_campaign: stored.utm_campaign || '',
      utm_content: stored.utm_content || '',
      utm_term: stored.utm_term || '',
      gclid: stored.gclid || '',
      fbclid: stored.fbclid || '',
      ttclid: stored.ttclid || '',
      msclkid: stored.msclkid || '',
      cart_has_sample: hasSample
    };
  }

  function bybCheckoutContents(cart) {
    return (cart || []).slice(0, 20).map(function (item) {
      var id = [item.product_type, item.fabric, item.colour].filter(Boolean).join('_');
      return {
        id: id || 'item',
        quantity: item.quantity || 1,
        item_price: Number(item.price) || 0
      };
    });
  }

  function bybFireCheckoutEvents(cart, eventId) {
    var hasSample = (cart || []).some(function (item) {
      return item && item.product_type === 'sample';
    });
    var contents = bybCheckoutContents(cart);
    var value = contents.reduce(function (sum, row) {
      return sum + (Number(row.item_price) || 0) * (Number(row.quantity) || 1);
    }, 0);
    var contentIds = contents.map(function (row) { return row.id; });
    var metaOpts = { eventID: eventId };

    try {
      if (typeof window.fbq === 'function') {
        window.fbq('track', 'InitiateCheckout', {
          content_ids: contentIds,
          contents: contents,
          currency: 'AUD',
          value: value,
          num_items: cart.length
        }, metaOpts);
        if (hasSample) {
          window.fbq('track', 'Lead', {
            content_name: 'free_samples',
            content_category: 'sample',
            currency: 'AUD',
            value: 0
          }, metaOpts);
        }
      }
    } catch (e) {}

    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'begin_checkout', {
          currency: 'AUD',
          value: value,
          event_id: eventId,
          items: contents.map(function (row) {
            return { item_id: row.id, quantity: row.quantity, price: row.item_price };
          })
        });
        if (hasSample) {
          window.gtag('event', 'generate_lead', {
            currency: 'AUD',
            value: 0,
            event_id: eventId,
            lead_type: 'free_samples'
          });
        }
      }
    } catch (e2) {}

    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('byb_initiate_checkout', {
          event_id: eventId,
          currency: 'AUD',
          value: value,
          num_items: cart.length
        });
        if (hasSample) {
          Shopify.analytics.publish('byb_sample_lead', {
            event_id: eventId,
            currency: 'AUD',
            value: 0
          });
        }
      }
    } catch (e3) {}
  }

  try { bybCaptureAttributionFromUrl(); } catch (eAttr) {}

  // 5. CHECKOUT (MIDDLEWARE TRIGGER)
  window.proceedToMiddleware = function() {
    const btn = document.getElementById('vc-checkout-btn');
    let cart = capVirtualCartSamples(readVirtualCart());
    if (cart.length === 0) return;

    const missingHem = cart.some((item) => item.product_type === 'curtain'
      && !['Lead weight', '70mm hem'].includes(item.options && item.options.hemFinish));
    if (missingHem) {
      alert('Choose a curtain hem (Lead weight or 70mm hem) before checkout.');
      return;
    }

    if (JSON.stringify(cart) !== JSON.stringify(readVirtualCart())) {
      localStorage.setItem('virtual_cart', JSON.stringify(cart));
      renderVirtualItems();
    }

    btn.innerText = "PREPARING CHECKOUT...";
    btn.classList.add('processing');

    const MIDDLEWARE_URL = "https://blind-middleware.vercel.app/api/checkout";
    var eventId = bybNewEventId();
    var attribution = bybBuildAttribution(eventId, cart);

    // Use applied discount from sessionStorage (validated at Apply); fallback to input
    var discountCode = getAppliedDiscount() || (document.getElementById('vc-discount-code') && document.getElementById('vc-discount-code').value.trim().toUpperCase()) || "";
    const payload = {
        items: cart,
        discountCode: discountCode,
        shop: Shopify.shop,
        attribution: attribution
    };

    fetch(MIDDLEWARE_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
    })
    .then(res => res.json())
    .then(data => {
        if(data.invoice_url) {
            var confirmedId = data.event_id || eventId;
            bybFireCheckoutEvents(cart, confirmedId);
            window.location.href = data.invoice_url;
        } else {
            alert("Error creating checkout: " + (data.error || "Unknown error"));
            btn.innerText = "PROCEED TO CHECKOUT";
            btn.classList.remove('processing');
        }
    })
    .catch(err => {
        console.error("Middleware Error:", err);
        alert("Connection failed. Please try again.");
        btn.innerText = "PROCEED TO CHECKOUT";
        btn.classList.remove('processing');
    });
  };

  // 6. LISTEN FOR UPDATES
  window.addEventListener('storage', () => {
    updateHeaderCartCount();
    const drawer = document.getElementById('virtual-cart-drawer');
    if (drawer && drawer.classList.contains('open')) {
      renderVirtualItems();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateHeaderCartCount);
  } else {
    updateHeaderCartCount();
  }

  function toggleCheckoutButton() {
    const checkbox = document.getElementById('vc-terms-checkbox');
    const btn = document.getElementById('vc-checkout-btn');
    const container = checkbox.closest('.vc-terms-consent');
    
    if (checkbox.checked) {
      btn.classList.remove('disabled');
      btn.disabled = false;
      container.classList.add('checked');
    } else {
      btn.classList.add('disabled');
      btn.disabled = true;
      container.classList.remove('checked');
    }
  }

